// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pill_action_411841df {
  cursor: pointer;
}
.pill_action_411841df:hover {
  background-color: #dce1e5;
}
.pill_action_411841df.pill_pressed_411841df {
  background-color: #c1c8cd;
}
.pill_411841df.pill__hovered {
  background-color: #dce1e5;
}
.pill_exclusion_411841df {
  background-color: #fee0d0;
  border: solid 0.084rem #b32700;
  color: #730008;
}
.pill_exclusion_411841df.pill_action_411841df:hover {
  background-color: #ffaf99;
}
.pill_exclusion_411841df.pill_action_411841df.pill_pressed_411841df {
  color: #fff;
  background-color: #b32700;
}
.pill_exclusion_411841df.pill_exclusion__hovered {
  background-color: #ffaf99;
}
.pill_addition_411841df {
  background-color: #e3f4f4;
  border: solid 0.084rem #40c2c9;
  color: #1a4f52;
}
.pill_addition_411841df.pill_action_411841df:hover {
  background-color: #c4edeb;
}
.pill_addition_411841df.pill_action_411841df.pill_pressed_411841df {
  background-color: #40c2c9;
}
.pill_addition_411841df.pill_addition__hovered {
  background-color: #c4edeb;
}
.pill__action-button_411841df {
  padding: 0 0.334rem;
  display: flex;
  align-items: center;
  line-height: 1.5rem;
  height: 100%;
}
.pill__action-button_411841df > i,
.pill__action-button_411841df span {
  cursor: pointer;
}
.pill__action-button_411841df:last-child {
  margin-right: -0.667rem;
}
.pill__prefix_411841df {
  padding-right: 0.334rem;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  line-height: 1.5rem;
}
.pill__animation_411841df {
  transition: all 300ms ease;
  animation: hide_411841df 400ms ease-in forwards, remove_411841df 400ms ease-in 400ms forwards;
}
.pill__name_411841df {
  vertical-align: top;
}
.pill__remove_411841df {
  display: none;
}
.pill__icon_411841df {
  display: flex;
  justify-content: space-around;
  align-items: center;
  line-height: 1.167rem;
  width: 1.167rem;
}
@-moz-keyframes hide_411841df {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@-webkit-keyframes hide_411841df {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@-o-keyframes hide_411841df {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes hide_411841df {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@-moz-keyframes remove_411841df {
  from {
    max-width: 300px;
  }
  to {
    max-width: 0;
  }
}
@-webkit-keyframes remove_411841df {
  from {
    max-width: 300px;
  }
  to {
    max-width: 0;
  }
}
@-o-keyframes remove_411841df {
  from {
    max-width: 300px;
  }
  to {
    max-width: 0;
  }
}
@keyframes remove_411841df {
  from {
    max-width: 300px;
  }
  to {
    max-width: 0;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pill_action": `pill_action_411841df`,
	"pill_pressed": `pill_pressed_411841df`,
	"pill": `pill_411841df`,
	"pill_exclusion": `pill_exclusion_411841df`,
	"pill_addition": `pill_addition_411841df`,
	"pill__action-button": `pill__action-button_411841df`,
	"pill__prefix": `pill__prefix_411841df`,
	"pill__animation": `pill__animation_411841df`,
	"hide": `hide_411841df`,
	"remove": `remove_411841df`,
	"pill__name": `pill__name_411841df`,
	"pill__remove": `pill__remove_411841df`,
	"pill__icon": `pill__icon_411841df`
};
export default ___CSS_LOADER_EXPORT___;
